/**
 * Drapeau français animé "en vague" (SVG pur).
 * Ondulation marquée via feTurbulence animé + feDisplacementMap.
 */
const FrenchFlag = ({ className = "" }) => (
    <span
        className={`fr-flag inline-block align-middle ${className}`}
        role="img"
        aria-label="Drapeau français"
        data-testid="french-flag"
    >
        <svg width="42" height="28" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <filter id="fr-wave" x="-15%" y="-25%" width="130%" height="150%">
                    <feTurbulence type="fractalNoise" baseFrequency="0.02 0.06" numOctaves="2" seed="3">
                        <animate
                            attributeName="baseFrequency"
                            dur="2s"
                            values="0.02 0.06; 0.035 0.11; 0.02 0.06"
                            repeatCount="indefinite"
                        />
                    </feTurbulence>
                    <feDisplacementMap in="SourceGraphic" scale="5.5" />
                </filter>
            </defs>
            <g filter="url(#fr-wave)">
                <rect x="0" y="0" width="10" height="20" fill="#0055A4" />
                <rect x="10" y="0" width="10" height="20" fill="#FFFFFF" />
                <rect x="20" y="0" width="10" height="20" fill="#EF4135" />
            </g>
            <rect x="0" y="0" width="30" height="20" fill="none" stroke="rgba(0,0,0,0.1)" strokeWidth="0.4" />
        </svg>
    </span>
);

export default FrenchFlag;
